import React, { FC, useContext } from 'react'

import PromoBanner from '@/components/pages/production/components/promo-banner'
import PromoContext from '@/context/promo/context'

import styles from './styles.module.scss'

const TicketInfoPromoBanner: FC = () => {
    const {
        selectors: { promo },
    } = useContext(PromoContext)

    if (!promo) return null

    return (
        <div className={styles.ticketInfoPromoBannerPadding}>
            <PromoBanner promo={promo} />
        </div>
    )
}

export default TicketInfoPromoBanner
